import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {FormattedMessage} from 'react-intl';

class ErrorDialog extends React.Component {

   render() {
      const actions = [
         <FlatButton
            label={<FormattedMessage id="general.gotIt"/>}
            primary={true}
            onTouchTap={this.props.handleClose}
         />,
      ];

      return (
         <Dialog
            actions={actions}
            modal={false}
            open={true}
            onRequestClose={this.props.handleClose}
            title={
               <div>
                  <FormattedMessage id="general.error"/>
               </div>
            }
            contentStyle={{width: "300px", maxWidth: "none"}}
            autoScrollBodyContent={true}
         >
            {this.props.errorMessage}
         </Dialog>
      )
   }
}

export default ErrorDialog;



// WEBPACK FOOTER //
// ./src/components/errorDialog.component.js